/* @ngInject */
const editFieldsModal = (
  $uibModal,
  wagonRequest,
  utils,
  toaster
) => {
  const self = {}

  self.open = (_fieldName, _fieldLabel, _data, _filteredData) => {
    return $uibModal.open({
      template: require('./editFields.html'),
      resolve: {
        data: () => {
          return _data
        },
        filteredData: () => {
          return _filteredData
        },
        fieldName: () => {
          return _fieldName
        },
        fieldLabel: () => {
          return _fieldLabel
        },
      },
      /* @ngInject */
      controller: (
        $scope,
        $uibModalInstance,
        fieldName,
        fieldLabel,
        wagonFields,
        data,
        filteredData,
      ) => {
        $scope.fieldValue = {}
        $scope.fieldName = fieldName
        $scope.fieldLabel = fieldLabel
        $scope.fieldsOptions = wagonFields
        $scope.filteredData = filteredData

        $scope.submit = async (_fieldName, _fieldValue) => {
          if (!confirm(`Êtes-vous sûr de vouloir modifier le champ "${_fieldName}" de ces ${filteredData.length} wagons avec la valeur "${_fieldValue || ''}" ?`)) {
            return
          }

          if ($scope.fieldsOptions[_fieldName].type.nature === 'date') {
            _fieldValue = utils.date.stringToServer(_fieldValue)
          }
          const loopPromises = []

          for (var i = 0; i < filteredData.length; i++) {
            try {
              const updateData = {
                name: _fieldName,
                value: _fieldValue,
                id: filteredData[i].id,
              }

              loopPromises.push(wagonRequest.updateField(updateData))
            } catch (error) {
              toaster.error(error)
            }
          }

          loopPromises.forEach(async (promise) => {
            const response = await promise
            utils.updateFromArray(data, response.wagon)
          })

          $uibModalInstance.close()
        }

        $scope.cancel = () => {
          $uibModalInstance.close()
        }
      },
    })
  }

  return self
}
export default editFieldsModal



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/wagon/modals/editFields.modal.js